import { render, staticRenderFns } from "./rewardShopPromotionEdit.vue?vue&type=template&id=2295f67a&scoped=true&"
import script from "./rewardShopPromotionEdit.vue?vue&type=script&lang=js&"
export * from "./rewardShopPromotionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2295f67a",
  null
  
)

export default component.exports